import { type RouteAlertsType, type RouteInfoTollsType } from '../../AssignmentApi';

export type RouteSummaryDataRouteTypeType =
    | 'base_route'
    | 'to_confirm'
    | 'to_assign'
    | 'current_in_realisation'
    | 'modified_by_operator';

export class RouteSummaryData {
    public routeType: RouteSummaryDataRouteTypeType = 'base_route';
    public title: string = '';
    public durationSeconds: number | null = null;
    public distanceMeters: number | null = null;
    public cost: number | null = null;
    public costDetails: Record<string, (number|null)[]> | null = null;
    public quantity: number | null = null; // ???
    public stops: number | null = null;
    public deliveries: number | null = null;
    public isLoading: boolean = false;
    public isEstimated: boolean = false;
    public estimateKey: string | null = null;
    public timeWindowsExceeded: number | null = null;
    public visible: boolean = false;
    public alerts: any = undefined;
    public tolls: RouteInfoTollsType | null = null;

    constructor(routeType: RouteSummaryDataRouteTypeType = 'base_route') {
        this.routeType = routeType;
    }

    reset() {
        this.durationSeconds = null;
        this.distanceMeters = null;
        this.cost = null;
        this.quantity = null;
        this.deliveries = null;
        this.stops = null;
        this.isLoading = false;
        this.isEstimated = false;
        this.estimateKey = null;
        this.timeWindowsExceeded = null;
        this.visible = false;
        this.alerts = null;
    }

    setLoading(isLoading: boolean) {
        this.isLoading = isLoading;
    }

    setQuantity(quantity: number) {
        this.quantity = quantity;
    }
}
